import {TextData} from './textData';
import {ExerciseMC} from './exerciseMC';
import {AnnisResponse} from '../../../openapi';

export class ApplicationState {
    public previewAnnisResponse: AnnisResponse;
    public exerciseList: ExerciseMC[];
    public mostRecentSetup: TextData;

    constructor(init?: Partial<ApplicationState>) {
        Object.assign(this, init);
    }
}
